//
// Copyright 2024 DXOS.org
//

import { EditorView } from '@codemirror/view';

import { fontMono } from '../../styles';

export const bulletListIndentationWidth = 24;
export const orderedListIndentationWidth = 36; // TODO(burdon): Make variable length based on number of digits.

export const formattingStyles = EditorView.theme({
  /**
   * Horizontal rule.
   */
  '& .cm-hr': {
    display: 'inline-block',
    width: '100%',
    height: '0',
    verticalAlign: 'middle',
    borderTop: '1px solid var(--color-cm-separator)',
    opacity: 0.5,
  },

  /**
   * Lists.
   */
  '& .cm-list-item': {},
  '& .cm-list-mark': {
    display: 'inline-block',
    textAlign: 'right',
    paddingRight: '0.5em',
    fontVariant: 'tabular-nums',
  },
  '& .cm-list-mark-bullet': {
    width: `${bulletListIndentationWidth}px`,
  },
  '& .cm-list-mark-ordered': {
    width: `${orderedListIndentationWidth}px`,
  },

  /**
   * Blockquote.
   */
  '& .cm-blockquote': {
    background: 'var(--color-cm-codeblock)',
    borderLeft: '2px solid var(--color-cm-separator)',
    paddingLeft: '1rem',
    margin: 0,
  },

  /**
   * Code and codeblocks.
   */
  '& code': {
    fontFamily: fontMono,
    color: 'var(--color-cm-code)',
    whiteSpace: 'nowrap',
  },
  '& .cm-code': {
    fontFamily: fontMono,
    color: 'var(--color-cm-code)',
  },
  // Inline code spans (triggered by backticks) use `cm-code-inline` + `font-mono`.
  // Different monospace font metrics can slightly overflow the fixed CodeMirror line box,
  // so constrain them to the target 24px height.
  '& .cm-code-inline': {
    fontFamily: fontMono,
    height: '24px',
    // display: 'inline-flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: 'var(--color-cm-code-inline)',
  },
  '& .cm-code-mark': {
    fontFamily: fontMono,
    height: '24px',
    display: 'inline-flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  '& .cm-codeblock-line': {
    background: 'var(--color-cm-codeblock)',
    paddingLeft: '1rem !important',
    paddingRight: '1.5rem !important',
  },
  '& .cm-codeblock-start': {
    borderTopLeftRadius: '.25rem',
    borderTopRightRadius: '.25rem',
  },
  '& .cm-codeblock-end': {
    borderBottomLeftRadius: '.25rem',
    borderBottomRightRadius: '.25rem',
  },

  /**
   * Task list.
   */
  '& .cm-task': {
    display: 'inline-flex',
    width: `${bulletListIndentationWidth}px`,
    height: '20px',
  },
  '& .cm-task-checkbox': {
    display: 'grid',
    margin: '0',
    transform: 'translateY(2px)',
  },

  /**
   * Table.
   */
  '.cm-table *': {
    fontFamily: fontMono,
    lineHeight: 1.5,
    textDecoration: 'none !important',
  },
  '.cm-table-head': {
    padding: '2px 16px 2px 0px',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    wordBreak: 'keep-all',
    textAlign: 'left',
    color: 'var(--color-subdued)',
    borderBottom: '1px solid var(--color-cm-separator)',
  },
  '.cm-table-cell': {
    padding: '2px 16px 2px 0px',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    wordBreak: 'keep-all',
    verticalAlign: 'top',
  },

  /**
   * Image.
   */
  '.cm-image': {
    display: 'block',
    height: '0',
  },
  '.cm-image.cm-loaded-image': {
    height: 'auto',
    borderTop: '0.5rem solid transparent',
    borderBottom: '0.5rem solid transparent',
  },
  '.cm-image-with-loader': {
    display: 'block',
    opacity: 0,
    transitionDuration: '350ms',
    transitionProperty: 'opacity',
  },
  '.cm-image-with-loader.cm-loaded-image': {
    opacity: 1,
  },
  '.cm-image-wrapper': {
    'grid-template-columns': '1fr',
    'display': 'grid',
    'margin': '0.5rem 0',
    'overflow': 'hidden',
    'transitionDuration': '350ms',
    'transitionProperty': 'height',
    '& > *': {
      'grid-row-start': 1,
      'grid-column-start': 1,
    },
  },
});
